module.exports = __webpack_public_path__ + "static/media/AdvancedReservoirCharacterisation.99627946.pdf";